// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  offboarding_url: "https://anet.agiratech.com/api/v2",
  api_url: "https://anet-api.agiratech.com",
  skill_matrix_api: "https://anet-api.agiratech.com/njs/asm/api/v1/",
  blog_url: "https://agira-blog-management-stage.herokuapp.com/",
  rim_url: "https://anet.agiratech.com/api/v2/",
  ahr_url: "https://ahr.agiratech.com",
  google_login_client_id:
    "804052763086-leqfgpv7tj7iti7uruqsk27jc1nn9nf5.apps.googleusercontent.com",
  microsoft_login_client_id: "95cfc872-6c7e-4c25-b8a6-33509098b273",
  Quarters: [
    {
      key: "Quarter1",
      value: "Quarter1 (April - June)",
      start_date: "2020-04-01",
      end_date: "2020-06-30",
    },
    {
      key: "Quarter2",
      value: "Quarter2 (July - September)",
      start_date: "2020-07-01",
      end_date: "2020-09-30",
    },
    {
      key: "Quarter3",
      value: "Quarter3 (October - December)",
      start_date: "2020-10-01",
      end_date: "2020-12-31",
    },
    {
      key: "Quarter4",
      value: "Quarter4 (January - March)",
      start_date: "2021-01-01",
      end_date: "2021-03-31",
    },
  ],
  Half_yearly: [
    {
      key: "First Half",
      value: "First Half (April - September)",
    },
    {
      key: "Second Half",
      value: "Second Half (October - March)",
    },
  ],
  Yearly: [
    {
      key: "Full Year",
      value: "Full Year (April - March)",
    },
  ],
  Month: [
    {
      key: "April",
      value: "April",
    },
    {
      key: "May",
      value: "May",
    },
    {
      key: "June",
      value: "June",
    },
    {
      key: "July",
      value: "July",
    },
    {
      key: "August",
      value: "August",
    },
    {
      key: "September",
      value: "September",
    },
    {
      key: "October",
      value: "October",
    },
    {
      key: "November",
      value: "November",
    },
    {
      key: "December",
      value: "December",
    },
    {
      key: "January",
      value: "January",
    },
    {
      key: "Feburary",
      value: "Feburary",
    },
    {
      key: "March",
      value: "March",
    },
  ],
};



// WEBPACK FOOTER //
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/environments/environment.ts